const TopCompaniesPreview = () => import(/* webpackChunkName: "site-top-companies-preview" */ './preview.vue');
const TopCompaniesTable = () => import(/* webpackChunkName: "site-top-companies-table" */ './table.vue');
const TopCompaniesDetail = () => import(/* webpackChunkName: "site-top-companies-detail" */ './detail.vue');

export default (Browser) => {
  Browser.register('TopCompaniesPreview', TopCompaniesPreview);
  Browser.register('TopCompaniesTable', TopCompaniesTable);
  Browser.register('TopCompaniesDetail', TopCompaniesDetail);
};
